import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M19 8a.997.997 0 00-.707.293L12 14.586 5.707 8.293a1 1 0 10-1.414 1.414l7 7a.997.997 0 001.414 0l7-7A1 1 0 0019 8z" fill="currentColor" /></svg>);